import { fromJS,List, Record } from "immutable";

import { LAYOUT_VIEW,ORIENTATION_ROW } from "../../../../constants/identifiers";
import createFromJS from "../../../createFromJS";

export const ViewLayoutRecord = Record({
  orientation: ORIENTATION_ROW,
  children: List(),
  viewType: LAYOUT_VIEW
});

createFromJS.registerCallback("ViewLayoutRecord", any => {
  return new ViewLayoutRecord(fromJS(any)).withMutations(o => {
    o.update("children", val => val.map(o => (typeof o === "string" ? o : createFromJS.ViewLayoutRecord(o))));
  });
});
